export class RedirectParamModel {
	public token: string;
	public azureToken: string;
	public refreshToken: string;
	public menuID: string;
}
